import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import {
  PrismButton,
  PrismCheckbox,
  PrismModal,
  PrismTooltip,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsCompetitorsInputAutocompleteCompetitor from 'lumen/components/settings/competitors/input-autocomplete-competitor';

import styles from './modal-add-competitor.module.css';

interface SettingsCompetitorsModalAddCompetitorSignature {
  Args: {
    addCompetitor: unknown;
    compsets: unknown;
    isPrimaryCompsetFull: unknown;
    isRMSTabActive: unknown;
    isSecondaryCompsetFull: unknown;
    isSecondaryCompsetVisible: unknown;
    onClose: unknown;
  };
}

export default class SettingsCompetitorsModalAddCompetitor extends Component<SettingsCompetitorsModalAddCompetitorSignature> {
  @tracked isPrimaryChecked = false;
  @tracked isSecondaryChecked = false;
  @tracked selectedHotelinfo = null;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get excludedHotelinfoIds() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      this.args.compsets?.uniqueCompetitors?.map((c) => c.hotelinfo.id) ?? []
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isAddButtonDisabled() {
    if (!this.selectedHotelinfo) {
      return true;
    }

    return (
      this.isCompsetCheckboxesVisible &&
      !this.isPrimaryChecked &&
      !this.isSecondaryChecked
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isCompsetCheckboxesVisible() {
    return !this.args.isRMSTabActive && this.args.isSecondaryCompsetVisible;
  }

  @action
  addCompetitor(): void {
    const activeCompsets = {
      isPrimary:
        !this.args.isRMSTabActive &&
        (!this.args.isSecondaryCompsetVisible || this.isPrimaryChecked),
      isSecondary: !this.args.isRMSTabActive && this.isSecondaryChecked,
      isRMS: this.args.isRMSTabActive,
    };

    // @ts-expect-error: Incorrect type
    this.args.addCompetitor(this.selectedHotelinfo, activeCompsets);
    // @ts-expect-error: Incorrect type
    this.args.onClose();
  }

  @action
  // @ts-expect-error: Incorrect type
  selectHotelinfo(hotelinfo): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.selectedHotelinfo = hotelinfo;
  }

  @action
  togglePrimary(): void {
    this.isPrimaryChecked = !this.isPrimaryChecked;
  }

  @action
  toggleSecondary(): void {
    this.isSecondaryChecked = !this.isSecondaryChecked;
  }

  <template>
    <PrismModal
      {{! @glint-expect-error: Incorrect type }}
      @onClose={{@onClose}}
      @title={{t "settings.competitors.add_competitor"}}
      data-test-id="modal-add-competitor"
    >
      <:default>
        <div class="modal--padded grid gap-400">
          <div>
            <label class={{styles.input-label}}>
              {{t "general.hotelname"}}
            </label>
            <div class="flex flex-col">
              <SettingsCompetitorsInputAutocompleteCompetitor
                @excludedHotelinfoIds={{this.excludedHotelinfoIds}}
                @selectHotelinfo={{this.selectHotelinfo}}
                @selectedHotelinfo={{this.selectedHotelinfo}}
                class="w-full"
              />
            </div>
          </div>

          {{#if this.isCompsetCheckboxesVisible}}
            <div>
              <label class={{styles.input-label}}>
                {{t "settings.competitors.compset_type"}}
              </label>
              <div class="grid justify-start gap-400">
                <span>
                  <PrismCheckbox
                    @checked={{this.isPrimaryChecked}}
                    {{! @glint-expect-error: Incorrect type }}
                    @disabled={{@isPrimaryCompsetFull}}
                    @onChange={{this.togglePrimary}}
                    data-test-id="checkbox-primary"
                  >
                    {{t "settings.competitors.primary_compset"}}
                  </PrismCheckbox>
                  {{#if @isPrimaryCompsetFull}}
                    <PrismTooltip
                      @side="right"
                      @text={{t "settings.competitors.global_limit_reached"}}
                    />
                  {{/if}}
                </span>

                <span>
                  <PrismCheckbox
                    @checked={{this.isSecondaryChecked}}
                    {{! @glint-expect-error: Incorrect type }}
                    @disabled={{@isSecondaryCompsetFull}}
                    @onChange={{this.toggleSecondary}}
                    data-test-id="checkbox-secondary"
                  >
                    {{t "settings.competitors.secondary_compset"}}
                  </PrismCheckbox>

                  {{#if @isSecondaryCompsetFull}}
                    <PrismTooltip
                      @side="right"
                      @text={{t "settings.competitors.global_limit_reached"}}
                    />
                  {{/if}}
                </span>
              </div>
            </div>
          {{/if}}
        </div>
      </:default>

      <:footer>
        <div class="flex h-full items-center justify-end gap-300 px-500">
          <PrismButton
            @buttonType="secondary"
            @label={{t "general.cancel"}}
            {{! @glint-expect-error: Incorrect type }}
            @onClick={{@onClose}}
            data-test-id="button-cancel"
          />
          <PrismButton
            @iconBefore="plus"
            {{! @glint-expect-error: Incorrect type }}
            @isDisabled={{this.isAddButtonDisabled}}
            @label={{t "settings.competitors.add_competitor"}}
            @onClick={{this.addCompetitor}}
            data-test-id="button-add-competitor"
          />
        </div>
      </:footer>
    </PrismModal>
  </template>
}
